import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Grid as GridContainer, Row, Col } from 'react-flexbox-grid'
import FullCalendar from 'fullcalendar-reactwrapper';
import 'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css';
import queryString from 'query-string'
import styled, { consolidateStreamedStyles } from 'styled-components'
import { push } from 'react-router-redux'
import moment from 'moment'
import R from 'ramda'
import { Form as UnstyledForm} from 'formsy-react-2'
import { Button, TextIcon, ModalSave ,Pagination, TextInput,Table, TableCell, TableHeader, Modal, TableLoading,ContextMenu} from 'advenio-components'
import ModalReservations from './ModalReservations'
import ReservationActions from '../../../Data/Redux/ParentPlatform/ReservationRedux'
import ServiceTypesActions from '../../../Data/Redux/ServiceTypesRedux'
import ConfirmDeleteModal from '../../../shared/ConfirmDeleteModal'
import { parseShortName, parseFullName, userHasRole } from '../../../utils/Utils'

const Grid = styled(GridContainer)`
  padding: 30px;
`
const PaginationContainer = styled.div`
  margin: 8px 5px;
  width:7%;
`
const FormContainer = styled.div`
  display: inline-block;
  width: 92%;
  margin-top: -19px;
`
const Form = styled(UnstyledForm)`
  display: inline-block;
  flex-direction: column;
  width: 31%;
  margin-left: 68%;
  @media only screen and (max-width:1366px) {
      margin-bottom: -2px;
      margin-top: 2px;
  }
`
const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 101%;
  height: auto;
`
const InputContainer = styled.div`
    margin-right: 5px;
    width: 151%;
`
const Send = styled.div`
  height: auto;
  display: inline;
  box-sizing: border-box;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: 6%;
`
const TableContainer = styled.div`
  margin: 8px;
`
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 78px;
}`

class Reservations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalReservationsOpen: false,
      pageSelected:1,
      queryParams: {},
      reservationId:0,
      modalReservationDeleteOpen:false,
      reservation:{},
      deleteNameService:'',
      reservations:[],
      reservationId:0
    }
  }  

  componentWillMount() {
      const { getReservation, getServiceTypes, activeChildren } = this.props
    // const queryParams = queryString.parse(search)
    // if (queryParams.page) {
    //   this.setState({ pageSelected: parseInt(queryParams.page) })
    // }
    // this.setState({ queryParams })
    getServiceTypes()
    getReservation(activeChildren.id)
    // getEmployees()

    // if(center_id !== undefined){
    //   getEmployeesAll()
    //   getClassroom(center_id)
    // }
  }
  componentWillReceiveProps(nextProps){
    let reservations =[]
    const {loadingReservations, childrenReservations} = nextProps

    if(!loadingReservations && childrenReservations !== undefined && childrenReservations !== this.props.childrenReservations){
      childrenReservations.map(s => {

        reservations.push({
          id: s.id,
          title: s.student,
          start: s.from_date+' '+moment(s.from_time,'hh:mm').format('HH:mm:ss'),
          end: s.to_date+' '+moment(s.to_time,'hh:mm').format("HH:mm:ss"),
          ...s
        })
      })
      this.setState({reservations})
      this.toggleModalReservations(false)
      this.toggleModalReservationDelete(false)

    }
  }

  
  /** Set type of modal and then open it */
  toggleModalReservations = (modalReservationsOpen = false,reservation = {}) => this.setState({ modalReservationsOpen,reservation })
  toggleModalReservationDelete = (reservationId = 0, modalReservationDeleteOpen = false) => this.setState({ modalReservationDeleteOpen, reservationId })
  

  render() {
    const { 
      serviceTypes, 
      user, 
      sendingReservation,
      activeChildren,
      deletingReservation,
      postReservation,
      deleteReservation,
      updateReservation,
      loadingReservations,
    } = this.props
    const { 
      modalReservationsOpen,
      modalReservationDeleteOpen,
      reservations,
      reservation,
      reservationId
    } = this.state
    if(loadingReservations){
      return  <Modal isOpened loading />
    }

    return (
      <div style={{ width:'98%',marginLeft:'18px' }}>
        <Grid fluid>
          {/* <Row middle="xs" between="xs">
            <Col><h1>Registro de Servicios</h1></Col>
          </Row> */}
          <Row>
            <Col>
              {/* https://classic.yarnpkg.com/es-ES/package/fullcalendar-reactwrapper#basic-usage */}
              <FullCalendar
                 id = "calendar"
                 customButtons= {{
                  myCustomButton: {
                  text: 'Agregar Reservación',
                    click: () => {this.toggleModalReservations(true)}
                  }
                }}
                buttonText={{today:'Hoy'}}
                header = {{
                    left: 'prevYear,prev,next,nextYear today',
                    center: 'title',
                    right: 'myCustomButton'// month,agendaWeek,agendaDay
                }}
                height={800}
                columnFormat={'dddd'}
                locale={'es'}
                navLinks= {false} // can click day/week names to navigate views
                editable= {true}
                eventLimit= {5} // allow "more" link when too many events
                selectable= {true}
                displayEventEnd={true} // show end Event
                eventStartEditable={false} // disabled drop
                hiddenDays= {[0,6]}
                selectAllow = {(select) => {
                  return !!(moment(select.start).isSameOrAfter(moment().add(2, 'days'))) 
               }}
                eventClick={(calEvent, jsEvent, view) => {
                 this.toggleModalReservations(true,calEvent)
                }}
                select= {(startDate,endDate) => {
                  const from_date = startDate.format()
                  const to_date = moment(endDate.format()).subtract(1,'days').format('YYYY-MM-DD')
                  const reservation = {
                    from_date,
                    to_date
                  }
                  this.toggleModalReservations(true,reservation)
                }}
                events = {reservations}//events
                eventColor={'#3E72D7'}
              />
            </Col>
          </Row>
        </Grid>
        {/* Modal de Valoracion Diaria */}
       {
          modalReservationsOpen && (
        <ModalReservations
          isOpen={modalReservationsOpen}
          child={activeChildren}
          isClose={() => this.toggleModalReservations(false)}
          // classroom={classroom}
          user={user}
          serviceTypes={serviceTypes}
          postReservation={postReservation}
          updateReservation={updateReservation}
          deleteReservation={ this.toggleModalReservationDelete}
          loading={sendingReservation}
          // centers={centers}
          reservation={reservation}
          // loadingRequest={loadingRequest}
        />)}
         {
          modalReservationDeleteOpen && (
            <ConfirmDeleteModal 
            isOpen={modalReservationDeleteOpen}
            onClose={() => this.toggleModalReservationDelete(0,false)}
            itemId={reservationId}
            handleSubmit={deleteReservation}
            loading={deletingReservation}
            typeToDelete={`Reservación`}
            modalTitle={activeChildren.first_name+' '+activeChildren.last_name_paternal}
            /> 
          )}
      </div>
    )
  }
}

Reservations.defaultProps = {
    loading: false,
    // employees: [],
  }
const mapStateToProps = (state ) => ({
  /** Error and loading for modal options */
    loadingReservations: state.parent_platform_reservation.get.fetching
      || state.service_types.get.fetching,
    sendingReservation: state.parent_platform_reservation.postReservation.fetching,
    childrenReservations: state.parent_platform_reservation.get.results,
    serviceTypes: state.service_types.get.results,
    deletingReservation: state.parent_platform_reservation.deleting.fetching,
})

 const mapDispatchToProps = dispatch => ({
  getReservation: studentId => dispatch(ReservationActions.getRequest(studentId,true)),
  getServiceTypes: studentId => dispatch(ServiceTypesActions.getRequest({},true)),
  postReservation: (studentId,data) => dispatch(ReservationActions.postReservationRequest(studentId,data)),
  updateReservation: (id,data) => dispatch(ReservationActions.updateReservationRequest(id,data)),
  deleteReservation: id => dispatch(ReservationActions.deleteReservationRequest(id)),
  // getEmployees: () => dispatch(EmployeesActions.getRequest({},true)),    
  // getEmployeesAll: () => dispatch(EmployeesActions.getAllEmployeeRequest({},true)),    
  // getClassroom: centerId => dispatch(EmployeesActions.getClassroomRequest(centerId,true)),    
  goTo: path => dispatch(push(path)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reservations))



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/Reservations/index.jsx